import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  GenericError,
  UrlPath,
  loaderStyle,
  PendingActive,
  Active,
  PendingApproval,
  Blocked,
  Cancelled,
  Rejected,
  PendingInactive,
  ProductDeliveryPlatforms,
  ProductTypes,
  positiveStatuses,
  Draft,
  Verbiage,
} from '../../constants';
import AgGridComponent from '../../sharedcomponents/ag-grid/AgGrid';
import { Endpoints, UserId, maxPageSize } from './../../constants';
import smartHttp from '../../helpers/smartHttp';
import { Notify } from './../../sharedcomponents/Alert/Notify';
import ProductsDropdown from './ProductsDropdown';
import UsersDropdown from './UsersDropdown';
import ProductDistributorsDropdown from './ProductDistributorsDropdown';
import DistributorUserIdModal from './DistributorUserIdModal';
import Loader from './../../components/Loader';
import StatusDefinitionHeader, {
  getStatusDefinition,
} from './StatusDefinitionHeader';
import { getSelectedContractNumbers } from '../../helpers/component-helper-methods';
import store from '../../redux/store';

const ProductEntitlements = ({ contracts, isBPMReferral }) => {
  const ManageUserIdDistributors =
    store.getState()?.dbConfig.ManageUserIdDistributors;
  const TradingEntityDistributorPlatforms = ManageUserIdDistributors?.filter(
    (item) => item.tradingEntity === 1,
  );

  const DistributorUserIDRequiredList = store
    .getState()
    ?.dbConfig.ManageUserIdDistributors?.filter(
      (item) => item.isRequired === 1,
    );

  const [loading, setLoading] = useState(false);
  const [productDataset, setProductDataset] = useState();
  const [deliveryPltfDataset, setDeliveryPltfDataset] = useState();
  const [usersDataSet, setUsersDataSet] = useState([]);
  const [updatedUsers, setUpdatedUsers] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDeliveryPltf, setSelectedDeliveryPltf] = useState([]);
  const [selectedDeliveryPltfId, setSelectedDeliveryPltfId] = useState([]);
  const [selectedParentCascade, setSelectedParentCascade] = useState();
  const [filteredProducts, setFilteredProducts] = useState();
  const [filteredDeliveryPlatforms, setFilteredDeliveryPlatforms] = useState();
  const [uniqAvailableMappings, setUniqAvailableMappings] = useState();
  const [entitlementData, setEntitlementData] = useState([]); // Holds the list of current entitlements for the selected contracts
  const [productsDistributorData, setProductsDistributorData] = useState([]);
  const [packageMappingData, setPackageMappingData] = useState([]);
  const [showDistributorUserIdModal, setShowDistributorUserIdModal] = useState(
    [],
  );

  const callBackUsers = (props) => setUpdatedUsers(props);
  const callBackProducts = (params) => {
    if (!params || !Array.isArray(params)) {
      return;
    }
    setSelectedProducts(params);
  };
  const callBackDistributors = (params) => {
    let dstsId = [];
    params.forEach((dst) => {
      dstsId.push(dst.distributorId);
    });
    setSelectedDeliveryPltf(params);
    setSelectedDeliveryPltfId(dstsId);
  };
  const gridRef = useRef();
  const getColumnClass = (params) => {
    if (params?.node?.data?.isEntitlementExists == false) {
      return 'new-selected-entitlement-row grid-cell-left';
    } else {
      return 'grid-cell-left';
    }
  };

  const distributorGetter = (params) => {
    if (params?.data)
      return (
        params?.data?.distributorDisplayName +
        ' : ' +
        params?.data?.distributorPlatformDisplayName +
        ' (' +
        params?.data?.deliveryType +
        ')'
      );

    return '';
  };

  const columns = [
    {
      headerName: 'User',
      headerTooltip: 'User',
      field: 'contactData',
      tooltipField: 'contactData',
      initialFlex: 3,
      cellClass: getColumnClass,
    },
    {
      headerName: 'Package',
      headerTooltip: 'Package',
      field: 'packageName',
      tooltipField: 'packageName',
      initialFlex: 3,
      cellClass: getColumnClass,
    },
    {
      headerName: 'Product',
      headerTooltip: 'Product',
      field: 'productName',
      tooltipField: 'productName',
      initialFlex: 3,
      cellClass: getColumnClass,
    },
    {
      headerName: 'Delivery Platform (Type)',
      headerTooltip: 'Delivery Platform (Type)',
      field: 'deliveryPlatform',
      initialFlex: 3,
      valueGetter: distributorGetter,
      tooltipValueGetter: distributorGetter,
      cellClass: getColumnClass,
    },
    {
      headerName: 'Status',
      headerTooltip: 'Status',
      field: 'status',
      tooltipValueGetter: (params) => getStatusDefinition(params.value),
      headerComponent: StatusDefinitionHeader,
      initialFlex: 3,
      cellClass: getColumnClass,
    },
  ];

  const onDragStoppedHandler = (params) => {
    const columnDefs = columns;
    let groupCols = params.api.columnModel.rowGroupColumns;
    columnDefs.forEach(function (colDef, index) {
      if (groupCols.find((x) => x.colId === colDef.field)) {
        colDef.hide = true;
      } else {
        colDef.hide = false;
      }
    });
    gridRef.current.api.setGridOption('columnDefs', columnDefs);
  };

  const defaultConfig = {
    rowModelType: 'clientSide',
    isExportCSV: false,
    isExportExcel: false,
    pivotPanelShow: '',
    pagination: false,
    isAutoSizeColums: true,
    enableCharts: false,
    sideBar: false,
    onDragStopped: onDragStoppedHandler,
  };

  const defaultColdef = {
    sortable: true,
    resizable: true,
    menuTabs: ['generalMenuTab', 'filterMenuTab'],
    enableValue: false,
    cellClass: 'grid-cell-left',
  };

  const autoGroupColumnDef = {
    // column definition for grouped column
    enableRowGroup: false,
    lockPosition: 'left',
    lockPinned: true,
    sortable: true,
    cellRenderer: 'agGroupCellRenderer',
  };

  useEffect(() => {
    const reduceCallback = setTimeout(() => {
      setProductsDistributorData([]);
      setFilteredProducts();
      setSelectedProducts([]);
      setSelectedDeliveryPltf([]);
      setSelectedDeliveryPltfId([]);
      setUsersDataSet([]);
      getAllProductEntitlements();
    }, 1000);
    return () => clearTimeout(reduceCallback);
  }, [contracts]);

  useEffect(() => {
    // Set initial state
    if (productDataset && productDataset.results)
      setFilteredProducts(productDataset);
    if (deliveryPltfDataset && deliveryPltfDataset.results)
      setFilteredDeliveryPlatforms(deliveryPltfDataset);
  }, [productDataset, deliveryPltfDataset]);

  useEffect(() => {
    // Controller to abort previous API calls if any ongoing flight
    const controller = new AbortController();
    const signal = controller.signal;
    const reduceCallback = setTimeout(() => {
      // MODIFIED: Removed dependency on selectedDeliveryPltf - Product dropdown works independently
      // Original condition: if (selectedProducts.length > 0 && selectedDeliveryPltf.length > 0)
      if (selectedProducts.length > 0) {
        getContractProducts(signal, false);
      } else if (selectedProducts.length === 0) {
        // Original condition: selectedProducts.length === 0 || selectedDeliveryPltf.length === 0
        setProductsDistributorData(
          restoreExistingRows(productsDistributorData),
        );
      }
    }, 1000);
    return () => {
      clearTimeout(reduceCallback);
      controller?.abort();
    };
  }, [selectedProducts, usersDataSet]); // Removed selectedDeliveryPltf from dependencies

  // FEATURE DISABLED (US 9513362): Cascading logic for Delivery Platform dropdown - kept for future reference
  // useEffect(() => {
  //   if (selectedParentCascade === 'ProductDropdown' && uniqAvailableMappings) {
  //     // Filter distributor based on product selection
  //     let prodId = [];
  //     selectedProducts.forEach((el) => {
  //       prodId.push(el.productId);
  //     });
  //     let filterData = uniqAvailableMappings.filter((el) =>
  //       prodId.includes(el.productId),
  //     );
  //     setFilteredDeliveryPlatforms({ results: filterData });
  //   }
  // }, [selectedProducts]);

  // FEATURE DISABLED (US 9513362): Cascading logic for filtering products based on Delivery Platform - kept for future reference
  // useEffect(() => {
  //   if (
  //     selectedParentCascade === 'DistributorDropdown' &&
  //     uniqAvailableMappings
  //   ) {
  //     // Filter products based on distributor selection
  //     let filterData = uniqAvailableMappings.filter((el) => {
  //       return selectedDeliveryPltfId.includes(el.distributorId);
  //     });
  //     setFilteredProducts({ results: filterData });
  //   }
  // }, [selectedDeliveryPltfId]);

  useEffect(() => {
    handleUserCallback(updatedUsers);
  }, [updatedUsers]);

  // revert temporarily-blanked rows
  const restoreExistingRows = (rows = []) =>
    rows
      .map((r) =>
        !r.isEntitlementExists && r.originalStatus
          ? { ...r, status: r.originalStatus, isEntitlementExists: true }
          : r,
      )
      .filter((r) => r.isEntitlementExists);

  const getContractProducts = async (signal, isUserChanged = false) => {
    try {
      let productsDistributorResponse;

      if (!isUserChanged) {
        const productIdCollection = selectedProducts
          ?.map((el) => String(el.productId))
          .join(',');

        // FEATURE DISABLED (US 9513362): Delivery Platform dropdown is disabled - kept for future reference
        // let distributorIdCollection = selectedDeliveryPltf
        //   .map((el) => String(el.distributorId))
        //   .join(',');

        // MODIFIED: Removed distributorIdCollection check since Delivery Platform dropdown is disabled
        // Original condition: if (productIdCollection && distributorIdCollection) {
        if (productIdCollection) {
          const { contractNumbers, contractNumberFilter } =
            getSelectedContractNumbers(contracts);
          let productTypes = ProductTypes?.map((t) => '"' + t + '"').join(',');
          let filteredDeliveryPlatforms = ProductDeliveryPlatforms.map(
            (s) => `"${s}"`,
          ).join(',');
          // MODIFIED: Removed distributorId filter from query
          // Original Filter: `productId in(${productIdCollection}) AND distributorId in(${distributorIdCollection}) AND (distributor in (${filteredDeliveryPlatforms}) or producttype in (${productTypes})) and contractNumber in(${contractNumberFilter})`
          let queryParams = {
            PageSize: 5000,
            Filter: `productId in(${productIdCollection}) AND (distributor in (${filteredDeliveryPlatforms})) and contractNumber in(${contractNumberFilter})`,
          };
          setLoading(true);
          productsDistributorResponse = await smartHttp.get(
            Endpoints.contractProductsApi,
            queryParams,
          );
        }
      } else {
        // Handle user changed scenario if needed
        productsDistributorResponse = { data: { results: [] } };
      }

      // MODIFIED: Removed selectedDeliveryPltf.length check since Delivery Platform dropdown is disabled
      // Original condition: selectedProducts.length !== 0 && selectedDeliveryPltf.length !== 0 && usersDataSet.length !== 0
      if (
        selectedProducts.length !== 0 &&
        usersDataSet.length !== 0
      ) {
        let prepareProductsDistributorData = restoreExistingRows(
          productsDistributorData,
        );

        usersDataSet.forEach((u) => {
          productsDistributorResponse?.data?.results?.forEach((y) => {
            if (y.contractNumber !== u.contractNumber) return;

            const existing = prepareProductsDistributorData.find(
              (r) =>
                r.contactId === u.contactId &&
                r.productComponentId === y.productComponentId,
            );

            if (
              existing &&
              [Cancelled, Rejected, PendingInactive].includes(existing.status)
            ) {
              const updated = {
                ...existing,
                originalStatus: existing.originalStatus ?? existing.status,
                status: existing.status,
                isEntitlementExists: false,
              };

              prepareProductsDistributorData = [
                updated,
                ...prepareProductsDistributorData.filter((r) => r !== existing),
              ];
              return;
            }

            if (
              !prepareProductsDistributorData.some(
                (pd) =>
                  pd.contactId === u.contactId &&
                  pd.productComponentId === y.productComponentId &&
                  ([
                    PendingActive,
                    Active,
                    PendingApproval,
                    Draft,
                    Blocked,
                  ].includes(pd.status) ||
                    !pd.isEntitlementExists),
              )
            ) {
              y.distributorData =
                y.distributorDisplayName +
                ' : ' +
                y.distributorPlatformDisplayName +
                ' (' +
                y.deliveryType +
                ')';
              y.contactData = u.contactName;
              y.isEntitlementExists = false;
              y.status = '';
              y.contactId = u.contactId;
              prepareProductsDistributorData.unshift({ ...y });
            }
          });
        });
        setProductsDistributorData(prepareProductsDistributorData);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const productCompare = (current, next) => {
    if (current.productName < next.productName) {
      return -1;
    }
    if (current.productName > next.productName) {
      return 1;
    }
    return 0;
  };

  const getAllProductEntitlements = async () => {
    try {
      if (!contracts?.length || !contracts.some((el) => el.checked)) {
        setProductDataset({ results: [] });
        setDeliveryPltfDataset({ results: [] });
        return;
      }
      const { contractNumbers, contractNumberFilter } =
        getSelectedContractNumbers(contracts);
      if (!contractNumbers.length) {
        setProductDataset({ results: [] });
        setDeliveryPltfDataset({ results: [] });
        return;
      }
      const productFields =
        'productId,productName,productType,packageName,productComponentId,distributorId,distributor,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType,contractNumber,platformCategories';

      setLoading(true);
      let filteredDeliveryPlatforms = ProductDeliveryPlatforms.map(
        (s) => `"${s}"`,
      ).join(',');
      let productTypes = ProductTypes?.map((t) => '"' + t + '"').join(',');
      const [productRes, entitlementRes] = await Promise.all([
        smartHttp.get(Endpoints.contractProductsApi, {
          pageSize: maxPageSize,
          filter: `contractNumber in (${contractNumberFilter}) and distributor in (${filteredDeliveryPlatforms})`,
          Field: productFields,
        }),
        smartHttp.get(Endpoints.userentitlementsApi, {
          pageSize: maxPageSize,
          Field:
            'distributor,distributorId,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType',
          filter: `contractNumber in (${contractNumberFilter}) AND status IN (${positiveStatuses
            .map((s) => `"${s}"`)
            .join(',')})`,
        }),
      ]);
      // Save entitlement data for later use (e.g., for distributor filtering)
      const filteredEntitlementData = entitlementRes?.data?.results || [];
      setEntitlementData(filteredEntitlementData);

      // Filter distributors based on selected products and indicate if user already has entitlement for that distributor
      const entitlementDistributorIds = new Set(
        filteredEntitlementData.map(({ distributorId }) => distributorId),
      );

      const allProducts = productRes?.data?.results.map((item) => ({
        ...item,
        indicatePlatform: entitlementDistributorIds.has(item.distributorId),
      }));

      const uniquePrdDist = Array.from(
        new Map(
          allProducts.map((item) => [
            `${item.productId}_${item.distributorId}`,
            item,
          ]),
        ).values(),
      );
      setUniqAvailableMappings(uniquePrdDist || []);

      // Unique products based on productId and productComponentId
      const uniqueProducts = Array.from(
        new Map(
          allProducts.map((item) => [`${item.productId}`, item]),
        ).values(),
      );
      uniqueProducts?.sort(productCompare);
      setProductDataset({ results: uniqueProducts || {} });

      // Unique deliveryPlatforms based on distributorId and productComponentId
      const uniqueDeliveryPlatforms = Array.from(
        new Map(
          allProducts.map((item) => [`${item.distributorId}`, item]),
        ).values(),
      );
      setDeliveryPltfDataset({
        results: uniqueDeliveryPlatforms || [],
      });
    } catch (err) {
      setProductDataset({ results: [] });
      setDeliveryPltfDataset({ results: [] });
    } finally {
      setLoading(false);
    }
  };

  // get all entitlement mappings for user
  const getEntitlementMappings = (userIds, props) => {
    if (contracts && contracts.some((x) => x.checked)) {
      const { contractNumbers, contractNumberFilter } =
        getSelectedContractNumbers(contracts);
      let productTypes = ProductTypes?.map((t) => '"' + t + '"').join(',');
      let filteredDeliveryPlatforms = ProductDeliveryPlatforms.map(
        (s) => `"${s}"`,
      ).join(',');
      let queryParams = {
        pageSize: maxPageSize,
        Filter: `contractNumber in(${contractNumberFilter})
             AND contactid in(${userIds
               ?.map((t) => (t.contactId ? '"' + t.contactId + '"' : ''))
               .join(
                 ',',
               )}) AND distributor in (${filteredDeliveryPlatforms})`,
        Sort: 'statusSortOrder:asc,modifiedDate:desc',
      };
      setLoading(true);
      smartHttp
        .get(Endpoints.userentitlementsApi, queryParams, { useCache: false })
        .then((res) => {
          const response =
            res?.data?.results?.map((c, index) => {
              c.id = index;
              c.isEntitlementExists = true;
              c.distributorData =
                c.distributorDisplayName +
                ' : ' +
                c.distributorPlatformDisplayName +
                ' (' +
                c.deliveryType +
                ')';
              c.contactData = userIds.find(
                (x) => x.contactId == c.contactId,
              ).contactName;
              return c;
            }) ?? [];
          if (productsDistributorData.length > 0) {
            setProductsDistributorData([
              ...productsDistributorData,
              ...response,
            ]);
          } else {
            setProductsDistributorData(response);
          }
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
          if (props) setUsersDataSet(JSON.parse(JSON.stringify(props)));
        });
    } else {
      if (props) setUsersDataSet(JSON.parse(JSON.stringify(props)));
    }
  };

  const handleUserCallback = (props) => {
    //get users diff
    let removedUsers =
      props?.length > 0
        ? usersDataSet?.filter(
            (c) => !props.some((pc) => pc.contactId == c.contactId),
          )
        : usersDataSet;
    let addedUsers =
      usersDataSet?.length > 0
        ? props.filter(
            (c) => !usersDataSet.some((pc) => pc.contactId == c.contactId),
          )
        : props;

    // user added
    // add data to initials user entitlements
    if (addedUsers?.length > 0) {
      getEntitlementMappings(addedUsers, props);
    }
    // user removed
    // remove data from initial user entitlements
    if (removedUsers?.length > 0) {
      setProductsDistributorData(
        productsDistributorData.filter(
          (x) => !removedUsers.some((k) => k.contactId === x.contactId),
        ),
      );
      if (props) setUsersDataSet(JSON.parse(JSON.stringify(props)));
    }
  };

  // FEATURE DISABLED (US 9513362): Cascading dropdown logic - kept for future reference
  // const cascadingProductDistributor = () => {
  //   // On empty selection, set to default data
  //   if (
  //     selectedProducts.length === 0 &&
  //     selectedParentCascade === 'ProductDropdown'
  //   ) {
  //     setFilteredDeliveryPlatforms(deliveryPltfDataset);
  //   } else if (
  //     selectedDeliveryPltfId.length === 0 &&
  //     selectedParentCascade === 'DistributorDropdown'
  //   ) {
  //     setFilteredProducts(productDataset);
  //   }
  //
  //   // Cascading functionality to set which dropdown is parent
  //   if (selectedProducts.length === 0 && selectedDeliveryPltf.length === 0) {
  //     setSelectedParentCascade();
  //   } else if (!selectedParentCascade) {
  //     if (selectedProducts.length > 0) {
  //       setSelectedParentCascade('ProductDropdown');
  //     }
  //     if (selectedDeliveryPltf.length > 0) {
  //       setSelectedParentCascade('DistributorDropdown');
  //     }
  //   }
  // };
  const cascadingProductDistributor = () => {
    // Delivery Platform dropdown is disabled, no cascading needed
  };

  // FEATURE DISABLED (US 9513362): Memoized cascading selection - kept for future reference
  // const cascadingProductDistributorMemo = useMemo(cascadingProductDistributor, [
  //   selectedProducts,
  //   selectedDeliveryPltf,
  // ]);

  const onGridReadyHandler = (params) => {
    gridRef.current = params;
    params?.api?.showLoadingOverlay();
  };

  const validateUserId = (requiredEntitlements, entitleToSave) => {
    try {
      let distributorIdCollection = [];
      let contactIdCollection = [];
      let uniqueRequiredEntitlements = [];
      requiredEntitlements.forEach((el, i) => {
        // Get only unique records
        if (
          !uniqueRequiredEntitlements.some(
            (x) =>
              x.contactId === el.contactId &&
              x.distributorId === el.distributorId,
          )
        ) {
          uniqueRequiredEntitlements.push(el);
        }

        distributorIdCollection.push(el.distributorId);
        contactIdCollection.push(el.contactId);
      });

      // create Unique ID's of distributor with userId required
      let uniqueDistributorIdCollection = [...new Set(distributorIdCollection)];
      let uniqueContactIdCollection = [...new Set(contactIdCollection)];

      // create query using above data
      distributorIdCollection = uniqueDistributorIdCollection
        .map((el) => el)
        .join(',');
      contactIdCollection = uniqueContactIdCollection
        .map((el) => `"${el}"`)
        .join(',');

      let queryParams = {
        Filter: `distributorId in(${distributorIdCollection}) and contactId in(${contactIdCollection})`,
        PageSize: maxPageSize,
        id: String(Date.now()),
      };
      setLoading(true);
      smartHttp
        .get(Endpoints.distributorUserApi, queryParams)
        .then(async (res) => {
          let distributorUser = res?.data?.results;

          uniqueRequiredEntitlements.map((re) => {
            let userIdExist = distributorUser?.find(
              (du) =>
                du.distributorId == re.distributorId &&
                du.contactId == re.contactId,
            );
            re.isValidated = userIdExist ? true : false;
          });
          // Check if all Distributor Platforms has User ID
          if (uniqueRequiredEntitlements.every((x) => x.isValidated)) {
            saveEntitlements(entitleToSave);
          } else {
            let distributorUserIdModalData = uniqueRequiredEntitlements.filter(
              (x) => !x.isValidated,
            );

            setShowDistributorUserIdModal(distributorUserIdModalData);
          }
        })
        .catch((err) => {
          Notify({
            alert: true,
            type: 'error',
            title: GenericError.somethingWentWrong,
          });
        })
        .finally(() => setLoading(false));
    } catch (err) {}
  };

  const saveEntitlements = (postData, showAlert = true) => {
    let entitlementsForSave = postData.map((en) => {
      return {
        userEntitlementId: '-1',
        contactId: en.contactId,
        productComponentId: en.productComponentId,
        contractNumber: en.contractNumber,
        status: PendingActive, // FEATURE DISABLED (Release july-2026) - was: isBPMReferral ? Draft : PendingActive
      };
    });
    let entitlementModel = {
      userEntitlements: entitlementsForSave,
      userId: UserId,
    };
    setLoading(true);
    smartHttp
      .post(Endpoints.userentitlementsApi, entitlementModel)
      .then((res) => {
        if (res.data === 0) {
          smartHttp.clearCache(Endpoints.userentitlementsApi);
          Notify({
            alert: showAlert,
            type: 'success',
            title: 'Entitlements Added',
            onConfirm: () => afterSaveClick(),
          });
        }
      })
      .catch((err) => {
        // FEATURE DISABLED (Release july-2026) - LME Governance Check (Story 9836589)
        // let errorMsg =
        //   err?.response?.data === -3
        //     ? Verbiage.lmeEntitlementsGovernanceFailed
        //     : GenericError.somethingWentWrong;
        let errorMsg = GenericError.somethingWentWrong;
        Notify({
          alert: true,
          type: 'error',
          title: errorMsg,
        });
      })
      .finally(() => setLoading(false));
  };

  const handleEntitlementSave = () => {
    saveEntitlements(productsDistributorData);
    setShowDistributorUserIdModal([]);
  };

  const handleClose = () => {
    setShowDistributorUserIdModal([]);
  };

  const onSaveHandler = () => {
    try {
      // MODIFIED: Removed selectedDeliveryPltf.length check since Delivery Platform dropdown is disabled
      // Original condition: selectedProducts.length !== 0 && selectedDeliveryPltf.length !== 0 && usersDataSet.length !== 0 && productsDistributorData.length > 0
      if (
        selectedProducts.length !== 0 &&
        usersDataSet.length !== 0 &&
        productsDistributorData.length > 0
      ) {
        let entitleToSave = productsDistributorData.filter(
          (e) => !e.isEntitlementExists,
        );
        let requiredEntitlements = entitleToSave.filter(
          (en) =>
            DistributorUserIDRequiredList.some(
              (e) => e.distributorId === en.distributorId,
            ) ||
            TradingEntityDistributorPlatforms.some(
              (x) => x.distributorId === en.distributorId,
            ),
        );
        if (requiredEntitlements && requiredEntitlements.length > 0) {
          validateUserId(requiredEntitlements, entitleToSave);
        } else {
          saveEntitlements(entitleToSave);
        }
      }
    } catch (err) {}
  };

  const saveClick = () => {
    onSaveHandler();
  };

  const navigate = useNavigate();
  const afterSaveClick = () => {
    navigate(UrlPath.entitlements);
  };

  return (
    <>
      {showDistributorUserIdModal.length > 0 && (
        <DistributorUserIdModal
          filteredDistributorUserIdData={showDistributorUserIdModal}
          handleEntitlementSave={handleEntitlementSave}
          handleClose={handleClose}
        />
      )}
      {loading && <Loader type="scaleLoader" cssClass={loaderStyle} />}
      <Container fluid>
        <Row>
          <Col>
            <div className="add-entitlements left-0 mt-2">
              {/* Manage Email Preferences */}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <UsersDropdown
              contracts={contracts}
              callBackUsers={callBackUsers}
              isGroupFilterApply={true}
            />
          </Col>
          <Col>
            <ProductsDropdown
              DataSet={filteredProducts}
              callBackProducts={callBackProducts}
            />
          </Col>
          {/* Delivery Platform dropdown disabled - kept for future reference */}
          {/* <Col>
            <ProductDistributorsDropdown
              DataSet={filteredDeliveryPlatforms}
              callBackDistributors={callBackDistributors}
            />
          </Col> */}
        </Row>
        <Row>
          <Col>
            <div className="ag-grid-add-entitlement-table">
              <div
                className={
                  productsDistributorData &&
                  productsDistributorData.length > 0 &&
                  usersDataSet.length !== 0
                    ? 'd-none'
                    : 'd-block starter-text'
                }
              >
                <h4>Select any item</h4>
                <p>
                  Select Users, Products and Delivery Platform to start the
                  Entitlement Provision Process.
                </p>
              </div>
              <div
                className={
                  productsDistributorData &&
                  productsDistributorData.length > 0 &&
                  usersDataSet.length !== 0
                    ? 'd-block ag-grid-add-entitlement-table'
                    : 'd-none'
                }
              >
                <AgGridComponent
                  autoGroupColumnDef={autoGroupColumnDef}
                  config={defaultConfig}
                  defaultColumnDef={defaultColdef}
                  data={productsDistributorData}
                  columns={columns}
                  onGridReady={onGridReadyHandler}
                />
                <Col className="float-end mt-2 mb-2">
                  <button
                    className="btn btn-dark btn-opacity"
                    onClick={saveClick}
                    disabled={productsDistributorData?.every(
                      (x) => x.isEntitlementExists,
                    )}
                  >
                    SAVE ENTITLEMENTS
                  </button>
                </Col>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProductEntitlements;
